import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import appConfig from '../configs/appConfig';

import renderField from './render/renderField';
import { validateFirstStep } from './validate/validateSignUpForm';


const SignUpFormFirstStep = (props) => {
  const { handleSubmit, submitting } = props;
  const appSiteUrl = appConfig.APP_SITE_URL;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="email"
        type="email"
        component={renderField}
        label="Email"
      />
      <div className="auth-btns-wrap">
        <button
          type="submit"
          className="button"
          disabled={submitting}
        >
          Далее
        </button>
        <button
          type="button"
          className="button button_color_dark-blue"
          onClick={() => window.location.assign(`${appSiteUrl}/signup`)}
        >
          Регистрация работодателя
        </button>
      </div>
    </form>
  );
};

SignUpFormFirstStep.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'signUpFull',
  validate: validateFirstStep,
})(SignUpFormFirstStep);
